export type IMaskPercentFields = IDCA.IGenericFunc;

export function _maskPercentFields(): void {
  $('input.percent-field').each((_, elm) => {
    const $elm = $(elm);
    const precisionNum = !Number.isNaN(Number($elm.data('precision')))
      ? Number($elm.data('precision'))
      : 0;
    ($elm as any).maskMoney({
      allowNegative: false,
      allowZero: true,
      decimal: '.',
      precision: precisionNum,
      thousands: '',
    });
  });
}
